export default "__VITE_ASSET__74f2f93a__"